define('responsive-gameday/views/Monitor/ViewModels/distributors/PanelTabsDistributor',['require','exports','module','message-service/message-service','../../Events/ViewModelUpdateEvents','../../../../helpers/GamePanelViewConfig','gameday-index-url-hasher/UrlHasher','gameday-business-rules/gameday-business-rules','jquery'],function(require,exports,module) {
    var MessageService = require("message-service/message-service"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        GamePanelViewConfig = require("../../../../helpers/GamePanelViewConfig"),
        UrlHasher = require( "gameday-index-url-hasher/UrlHasher" ),
        GamedayRules = require("gameday-business-rules/gameday-business-rules").getInstance();

        $ = require("jquery");
    var gameData;
    var panelListData;
    var options;
    var rules = {};

    exports.setGameData = function(game) {
        gameData = $.extend({}, game); // type: object

        buildSendDataPack();

        MessageService.off(UpdateEvents.REQUEST_PANELTABS,handleUpdateRequest)
        MessageService.on(UpdateEvents.REQUEST_PANELTABS,handleUpdateRequest);
        
    };
    
    function handleUpdateRequest(){
        gameData = GDC.getGameData();
        buildSendDataPack(true)
    }
    // this return an Objcet
    function buildSendDataPack() {
        var liveState = UrlHasher.getHashParams().game_state,
            panelListData = GamePanelViewConfig('full', liveState),
            isST = (gameData.linescore.game_type.toUpperCase() === 'S'),
            gameyear = gameData.linescore.time_date.split("/")[0] *1,
            isOldGame = (gameyear < 2015) ? true : false,
            tempObj = {
                state : liveState,
                tabs  :[]
            };

      var removeColorFeedTab = false;
      
      rules.hideColorFeedSpringTraining = GamedayRules.options.hideColorFeedSpringTraining;
      rules.hideColorFeedPrior2015 = GamedayRules.options.hideColorFeedPrior2015;

      //new games && non-ST
      if (!isST && !isOldGame) {
         removeColorFeedTab = false;
      }
      
      //ST && need to hide
      if (isST &&  rules.hideColorFeedSpringTraining) {
         removeColorFeedTab = true;
      }
      
       //OldGame && need to hide
      if (isOldGame && rules.hideColorFeedPrior2015) {
         removeColorFeedTab = true;
      }
      
    
      if (!removeColorFeedTab) {
         tempObj.tabs =  panelListData;

      }else{
        tempObj.tabs = panelListData.filter(function(element) {return (element.id !== 'color')});  
      }
      MessageService.publish(UpdateEvents.UPDATE_PANELTABS,tempObj);
      return tempObj;
    }

      

});

